import React from 'react';
import PropTypes from 'prop-types';

import {
  ROLES,
  MODERATOR,
  BILLER,
  JORNALIST,
  EDITOR,
  CORRECTOR,
  SUPERVISOR,
} from 'utils/roles';

import Checkbox from 'components/Checkbox';

import Wrapper from './Wrapper';

class RolesForm extends React.PureComponent {
  state = {
    moderator: this.props.roles.indexOf(MODERATOR) !== -1,
    biller: this.props.roles.indexOf(BILLER) !== -1,
    journalist: this.props.roles.indexOf(JORNALIST) !== -1,
    editor: this.props.roles.indexOf(EDITOR) !== -1,
    corrector: this.props.roles.indexOf(CORRECTOR) !== -1,
    supervisor: this.props.roles.indexOf(SUPERVISOR) !== -1,
  };

  componentDidUpdate(prevProps) {
    if (this.props.roles !== prevProps.roles) {
      this.setState({ // eslint-disable-line react/no-did-update-set-state
        moderator: this.props.roles.indexOf(MODERATOR) !== -1,
        biller: this.props.roles.indexOf(BILLER) !== -1,
        journalist: this.props.roles.indexOf(JORNALIST) !== -1,
        editor: this.props.roles.indexOf(EDITOR) !== -1,
        corrector: this.props.roles.indexOf(CORRECTOR) !== -1,
        supervisor: this.props.roles.indexOf(SUPERVISOR) !== -1,
      });
    }
  }

  handleChange = (event) => {
    const nextState = {
      ...this.state,
      [event.target.id]: event.target.checked,
    };

    const enabledRoles = Object.keys(nextState).reduce((roles, role) => (
      nextState[role] ? roles.concat(role) : roles
    ), []);

    this.props.onRolesChange(enabledRoles);
  }

  render() {
    return (
      <Wrapper>
        {ROLES.map((role) => {
          if (role.value === SUPERVISOR && this.props.hideSupervisor) return null;

          return (
            <Checkbox
              key={role.value}
              id={role.value}
              checked={this.state[role.value]}
              onChange={this.handleChange}
              toggle
              disabled={this.props.loading}
            >
              {role.label}
            </Checkbox>
          );
        })}
      </Wrapper>
    );
  }
}

RolesForm.propTypes = {
  roles: PropTypes.arrayOf(
    PropTypes.oneOf([EDITOR, SUPERVISOR, MODERATOR, CORRECTOR, BILLER, JORNALIST])
  ).isRequired,
  onRolesChange: PropTypes.func,
  loading: PropTypes.bool,
  hideSupervisor: PropTypes.bool,
};

RolesForm.defaultProps = {
  onRolesChange: () => {},
  loading: false,
  hideSupervisor: false,
};

export default RolesForm;
